import { computed, type ComputedRef } from 'vue';
import type { ChangelogEntry, ChangelogFile } from '@/types/changelog';
import defaultChangelogData from '../../docs/changelog.json';

/**
 * Composable that exposes sorted changelog versions and the current version.
 * Accepts an optional data override for testing purposes.
 * @param dataOverride - Optional changelog data to use instead of the default JSON import.
 */
export const useChangelog = (dataOverride?: ChangelogFile): {
  versions: ComputedRef<ChangelogEntry[]>;
  currentVersion: ComputedRef<string | null>;
} => {
  const data = dataOverride ?? (defaultChangelogData as ChangelogFile);

  // Antéchronological sort on ISO date string (lexicographic descending).
  const versions = computed<ChangelogEntry[]>(() =>
    [...data.versions].sort((a, b) => b.date.localeCompare(a.date))
  );

  const currentVersion = computed<string | null>(() =>
    data.currentVersion === '0.0.0' ? null : data.currentVersion
  );

  return { versions, currentVersion };
};
